import React, { useState, useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { makeStyles } from '@mui/styles';
import { useTranslation } from "react-i18next";
import {
  Modal,
  Typography, Switch, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, InputLabel, FormControl, Button as MuiButton, Badge, Tooltip, Checkbox, ListItemText, Box, Chip, OutlinedInput
} from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import Button from "components/CustomButtons/Button.js";
import AlertDialog from '../components/AlertDialog';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import { colors } from '../components/Theme/WebTheme';
import moment from 'moment/min/moment-with-locales';
import { downloadCsv } from '../common/sharedFunctions';
import { useNavigate, useLocation } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import BlankTable from '../components/BlankTable';
import ImageViewerModal from '../components/ImageViewerModal';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DescriptionIcon from '@mui/icons-material/Description';
import SecurityIcon from '@mui/icons-material/Security';

const CAR_REJECTION_KEYS = [
  "reupload_car_image",
  "reupload_car_registration",
  "reupload_car_insurance",
  "reupload_all_images",
  "please_provide_correct_information"
];

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  submit3: {
    width: '100%',
    borderRadius: 3,
    marginTop: 2,
    padding: 4
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default function CarsList() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const userdata = useSelector(state => state.usersdata);
  const auth = useSelector(state => state.auth);
  const [drivers, setDrivers] = useState([]);
  const {
    updateUserCar,
    editCar
  } = api;
  const [driversObj, setDriversObj] = useState();
  const [data, setData] = useState([]);
  const cartypes = useSelector(state => state.cartypes);
  const carlistdata = useSelector(state => state.carlistdata);
  const dispatch = useDispatch();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [role, setRole] = useState(null);
  const { state } = useLocation();

  useEffect(() => {
    if (role !== 'driver' && userdata.users) {
      let arr = userdata.users.filter(user => user.usertype === 'driver' && ((role === 'fleetadmin' && user.fleetadmin && user.fleetadmin === auth.profile.uid) || role === 'admin' || role === 'subadmin'));
      let obj = {};
      let obj2 = {};
      let arr2 = [];
      for (let i = 0; i < arr.length; i++) {
        let user = arr[i];
        arr2.push({ id: user.id, desc: user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin ? user.email : "Hidden") });
        obj[user.id] = user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin ? user.email : "Hidden");
        obj2[user.id] = user.fleetadmin ? user.fleetadmin : null
      }
      setDrivers(arr2);
      setDriversObj(obj);
    }
  }, [userdata.users, settings.AllowCriticalEditsAdmin, role, auth.profile.uid]);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    if (carlistdata.cars) {
      setData(carlistdata.cars.map(car => ({ ...car })))
    } else {
      setData([]);
    }
  }, [carlistdata.cars]);

  const handleProfileModal = (e) => {
    setProfileModal(false);
  }

  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] = useState(false);
  const [viewerState, setViewerState] = useState({ open: false, src: '', title: '' });
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [, setLoading] = useState(false);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const onClick = (rowData) => {
    setProfileModal(true);
    setUserData(rowData);
  };

  const [category, setCategory] = useState([]);
  const [categoryObj, setCategoryObj] = useState(null);
  const [carType, setCarType] = useState([]);
  const [carTypeObj, setCarTypeObj] = useState(null);

  const [selectCategory, setSelectCategory] = useState(null);
  const [driver, setDriver] = useState(null);
  const [selectCartype, setSelectCartype] = useState(null);
  const navigate = useNavigate();

  const handelchangeCategory = (event, newValue) => {
    setSelectCategory(newValue);
    setSelectCartype();
    if (cartypes.cars) {
      let arr = [];
      for (let i = 0; i < cartypes.cars.length; i++) {
        if (newValue) {
          if (newValue.value === cartypes.cars[i].category) {
            arr.push({ label: cartypes.cars[i].name, value: cartypes.cars[i].name });
          }
        } else {
          setCarType([]);
        }
      }
      setCarType(arr);
    }
  }

  const handelchangeDriver = (event, newValue) => {
    setDriver(newValue)
  }

  const handelchangeCartype = (event, newValue) => {
    setSelectCartype(newValue)
  }

  useEffect(() => {
    if (cartypes.cars) {
      let arr = [];
      for (let i = 0; i < cartypes.cars.length; i++) {
        arr.push({ label: cartypes.cars[i].category, value: cartypes.cars[i].category });
      }
      let newArray = [];
      let uniqueObject = {};
      for (let i in arr) {
        let objTitle = arr[i]['label'];
        uniqueObject[objTitle] = arr[i];
      }
      for (let i in uniqueObject) {
        newArray.push(uniqueObject[i]);
      }
      setCategory(newArray);
    }
  }, [cartypes.cars]);

  useEffect(() => {
    if (cartypes.cars) {
      setCategoryObj(cartypes.cars[0] && cartypes.cars[0].category ? cartypes.cars[0].category : null);
    }
  }, [cartypes.cars]);

  useEffect(() => {
    if (cartypes.cars) {
      setCarTypeObj(cartypes.cars[0] && cartypes.cars[0].name ? cartypes.cars[0].name : null);
    }
  }, [cartypes.cars]);

  const handelApproved = (rowData, isApproving) => {
    if (isApproving) {
      if (settings.carApproval && (role === "admin" || role === 'subadmin')) {
        dispatch(
          updateUserCar(rowData.driver, {
            carApproved: true,
          })
        );
        dispatch(editCar({ ...rowData, approved: true, rejectionReason: null, hasNewCarUpload: false, carDocUpdated: false }, "Update"));
        if (rowData.driver) {
          api.fetchSingleUser(rowData.driver).then((user) => {
            const pushToken = user?.pushToken;
            const title = t('car_approved_title') && t('car_approved_title') !== 'car_approved_title' ? t('car_approved_title') : 'Your Car was approved.';
            const msg = t('car_approved_msg') && t('car_approved_msg') !== 'car_approved_msg' ? t('car_approved_msg') : 'Your car has been verified successfully.';
            if (pushToken) {
              api.RequestPushMsg(pushToken, {
                title: title,
                msg: msg,
                screen: 'DriverTrips',
                channelId: 'messages'
              });
            }
            if (api.firebase && api.firebase.userNotificationsRef) {
              try {
                api.push(api.firebase.userNotificationsRef(rowData.driver), {
                  dated: new Date().getTime(),
                  title: title,
                  msg: msg,
                  screen: 'DriverTrips'
                });
              } catch (e) {
                console.log("Notification push error:", e);
              }
            }
          });
        }
      }
    } else {
      setRejectCar(rowData);
      setRejectReasons([]);
      setCustomRejectReason("");
      setRejectDialogOpen(true);
    }
  };

  const handleRejectCar = () => {
    const allReasons = [...rejectReasons];
    if (customRejectReason && customRejectReason.trim() !== '') {
      allReasons.push(customRejectReason.trim());
    }
    if (rejectCar && allReasons.length > 0) {

      if (settings.carApproval && (role === "admin" || role === 'subadmin')) {
        dispatch(
          updateUserCar(rejectCar.driver, {
            carApproved: false,
          })
        );
        dispatch(editCar({ ...rejectCar, approved: false, rejectionReason: allReasons, hasNewCarUpload: false, carDocUpdated: false }, "Update"));
        if (rejectCar.driver) {
          api.fetchSingleUser(rejectCar.driver).then((user) => {
            const pushToken = user?.pushToken;
            const title = t('car_rejected_title') && t('car_rejected_title') !== 'car_rejected_title' ? t('car_rejected_title') : 'Your Car not approved.';
            const msg = allReasons.map(r => t(r, r)).join(', ');
            if (pushToken && allReasons.length > 0) {
              api.RequestPushMsg(pushToken, {
                title: title,
                msg: msg,
                screen: 'CarEdit',
                channelId: 'messages',
                params: { car: { ...rejectCar, approved: false, rejectionReason: allReasons } }
              });
            }
            if (api.firebase && api.firebase.userNotificationsRef && allReasons.length > 0) {
              try {
                api.push(api.firebase.userNotificationsRef(rejectCar.driver), {
                  dated: new Date().getTime(),
                  title: title,
                  msg: msg,
                  screen: 'CarEdit',
                  params: { car: { ...rejectCar, approved: false, rejectionReason: allReasons } }
                });
              } catch (e) {
                console.log("Notification push error:", e);
              }
            }
          });
        }
      }
    }
    setRejectDialogOpen(false);
    setRejectCar(null);
    setRejectReasons([]);
    setCustomRejectReason("");
  };


  const handelActiveStatus = (rowData) => {
    const updateData = { ...rowData, active: !rowData.active };
    return updateData;
  };

  const columns = [
    { title: t('createdAt'), field: 'createdAt', editable: 'never', defaultSort: 'desc', render: rowData => rowData.createdAt ? moment(rowData.createdAt).format('lll') : null, },
    {
      title: t('driver'), field: 'driver', editable: 'onAdd',
      render: rowData => {
        if (rowData && rowData.driver) {
          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'flex-start' }}>
              <span>{driversObj && driversObj[rowData.driver] ? driversObj[rowData.driver] : rowData.driver}</span>
              <MuiButton
                size="small"
                variant="contained"
                color="primary"
                style={{ textTransform: 'none', fontSize: '11px', padding: '2px 8px', marginTop: '4px' }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/users/driverdetails/${rowData.driver}`, { state: { tab: 2, pageNo: currentPage } });
                }}
              >
                {t('driver_cars', { defaultValue: "Driver's Cars" })}
              </MuiButton>
            </div>
          );
        }
      },
      editComponent: props => (
        <Autocomplete
          id="combo-box-demo"
          options={drivers}
          getOptionLabel={(option) => option.desc}
          style={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Combo box" variant="outlined" />}
          onChange={handelchangeDriver}
          disableClearable={true}
          value={driver}
        />
      ),
      exportTransformer: (rowData) => driversObj[rowData.driver],
      hidden: role === 'driver' ? true : false,
    },

    {
      title: t('category'), field: 'category',
      render: rowData => {
        if (rowData && rowData.category) {
          return t(`${rowData.category}`)
        }
      },
      editComponent: props => (
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={category}
          sx={{ width: 200 }}
          renderInput={(params) => <TextField {...params} label={t('category')} />}
          onChange={handelchangeCategory}
          disableClearable={true}
          value={selectCategory}
        />
      ),
      exportTransformer: (rowData) => categoryObj[rowData.category],
      editable: 'onAdd'
    },

    {
      title: t('carType'), field: 'carType',
      render: rowData => {
        if (rowData && rowData.carType) {
          return rowData.carType ? rowData.carType : null
        }
      },
      editComponent: props => (
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={carType}
          sx={{ width: 200 }}
          renderInput={(params) => <TextField {...params} label={t('carType')} />}
          onChange={handelchangeCartype}
          disableClearable={true}
          value={selectCartype}
        />
      ),
      exportTransformer: (rowData) => carTypeObj[rowData.carType],
      editable: 'onAdd'
    },
    {
      title: t('carcapacity'), field: 'capacity',
      render: rowData => (
        <span>{rowData.capacity} <span >{rowData.unit_type ? rowData.unit_type : ""}</span></span>
      ),
    },
    { title: t('vehicle_reg_no'), field: 'vehicleNumber' },
    { title: t('car_color', 'Color'), field: 'car_color' },
    { title: t('production_year', 'Production Year'), field: 'car_production_year' },
    { title: t('vehicle_model_name'), field: 'vehicleMake' },
    { title: t('vehicle_model_no'), field: 'vehicleModel' },
    { title: t('other_info'), field: 'other_info' },
    {
      title: t('image'), field: 'car_image',
      initialEditValue: 'https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png',
      render: rowData => (
        <button onClick={() => { onClick(rowData) }} style={{ border: 'none', background: 'none', cursor: 'pointer', padding: 0 }}>
          {rowData.car_image ? (
            <img
              alt='CarImage'
              src={rowData.car_image}
              style={{ width: 50, height: 35, objectFit: 'cover', borderRadius: 4, border: '1px solid #ddd', display: 'block' }}
              onError={(e) => {
                e.target.style.display = 'none';
                if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div style={{ width: 50, height: 35, borderRadius: 4, border: '1px dashed #ccc', display: rowData.car_image ? 'none' : 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fafafa' }}>
            <DirectionsCarIcon sx={{ fontSize: 20, color: '#aaa' }} />
          </div>
        </button>
      )
    },
    {
      title: t('active_status'), field: 'active', editable: (role === 'admin' || role === 'subadmin') ? 'never' : 'always', type: 'boolean', initialEditValue: true,
      render: (rowData) => (
        <Switch
          disabled
          checked={rowData.active}
          onChange={() => handelActiveStatus(rowData)}
        />
      ),
    },
    {
      title: t('approved'), field: 'approved', editable: (role === 'admin' || role === 'subadmin') ? 'always' : 'never', render: (rowData) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <Button
            size="small"
            variant={rowData.approved ? "contained" : "outlined"}
            style={{
              backgroundColor: rowData.approved ? 'green' : 'transparent',
              color: rowData.approved ? 'white' : 'green',
              borderColor: 'green',
              textTransform: 'none',
              minWidth: '110px'
            }}
            disabled={!(settings.AllowCriticalEditsAdmin && settings.carApproval && (role === "admin" || role === 'subadmin'))}
            onClick={() => handelApproved(rowData, true)}
          >
            {t('approved') || 'Approved'}
          </Button>
          <Button
            size="small"
            variant={!rowData.approved ? "contained" : "outlined"}
            style={{
              backgroundColor: !rowData.approved ? 'red' : 'transparent',
              color: !rowData.approved ? 'white' : 'red',
              borderColor: 'red',
              textTransform: 'none',
              minWidth: '110px'
            }}
            disabled={!(settings.AllowCriticalEditsAdmin && settings.carApproval && (role === "admin" || role === 'subadmin'))}
            onClick={() => handelApproved(rowData, false)}
          >
            {t('not_approved') || 'Not approved'}
          </Button>
        </div>
      ),
    },
    {
      title: t('car_messages', 'Car Messages'),
      field: 'rejectionReason',
      render: (rowData) => {
        const isApproved = rowData.approved;
        const msg = rowData.rejectionReason;
        const hasNewUpload = rowData.hasNewCarUpload || rowData.carDocUpdated;

        // In Driver Web Account:
        if (role === 'driver') {
          if (isApproved) {
            return (
              <Typography variant="body2" style={{ color: '#777', fontSize: 13 }}>
                {t('no_action_required', 'No action required')}
              </Typography>
            );
          }
          // After Driver has replaced the CarImage, CarDocument or Car information:
          // The notification text disappears, and default text / "Your Car pending approval" appears
          if (hasNewUpload) {
            return (
              <Typography variant="body2" style={{ color: '#d32f2f', fontWeight: 'bold', fontSize: 12 }}>
                {t('car_pending_approval', { defaultValue: 'Your Car pending approval' })}
              </Typography>
            );
          }
          // When not approved and not replaced yet: notification text from admin is shown
          const reasons = Array.isArray(msg)
            ? msg.filter(Boolean)
            : typeof msg === 'string'
              ? msg.split('\n').map(s => s.trim()).filter(Boolean)
              : [msg].filter(Boolean);

          if (reasons.length === 0) {
            return (
              <Typography variant="body2" style={{ color: '#d32f2f', fontWeight: 'bold', fontSize: 12 }}>
                {t('car_pending_approval', { defaultValue: 'Your Car pending approval' })}
              </Typography>
            );
          }

          const firstReason = t(reasons[0], reasons[0]);
          const fullTooltip = reasons.map((r, i) => `${i + 1}. ${t(r, r)}`).join('\n');

          return (
            <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{reasons.length > 1 ? fullTooltip : firstReason}</span>} arrow placement="top">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, overflow: 'hidden' }}>
                <Typography
                  variant="body2"
                  style={{
                    color: '#d32f2f',
                    fontWeight: 'bold',
                    fontSize: 12,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: reasons.length > 1 ? 140 : 200,
                    cursor: 'pointer'
                  }}
                >
                  {firstReason}
                </Typography>
                {reasons.length > 1 && (
                  <Chip
                    label={`+${reasons.length - 1}`}
                    size="small"
                    style={{
                      height: 20,
                      fontSize: 11,
                      backgroundColor: '#ffebee',
                      color: '#d32f2f',
                      fontWeight: 'bold',
                      cursor: 'pointer'
                    }}
                  />
                )}
              </div>
            </Tooltip>
          );
        }

        // In Admin Panel:
        if (isApproved) {
          return (
            <Typography variant="body2" style={{ color: '#777', fontSize: 13 }}>
              {t('no_action_required', 'No action required')}
            </Typography>
          );
        }

        const reasons = Array.isArray(msg)
          ? msg.filter(Boolean)
          : typeof msg === 'string'
            ? msg.split('\n').map(s => s.trim()).filter(Boolean)
            : [msg].filter(Boolean);

        if (reasons.length === 0) {
          if (hasNewUpload) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <Typography variant="body2" style={{ color: '#777', fontSize: 13 }}>
                  {t('no_action_required', 'No action required')}
                </Typography>
                <Tooltip title={t('new_car_document_uploaded', 'New car document or info updated by driver')}>
                  <Badge color="error" variant="dot">
                    <NotificationsActiveIcon style={{ color: '#ff9800', fontSize: 18 }} />
                  </Badge>
                </Tooltip>
              </div>
            );
          }
          return (
            <Typography variant="body2" style={{ color: '#777', fontSize: 13 }}>
              {t('no_action_required', 'No action required')}
            </Typography>
          );
        }

        const firstReason = t(reasons[0], reasons[0]);
        const fullTooltip = reasons.map((r, i) => `${i + 1}. ${t(r, r)}`).join('\n');

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, maxWidth: 220 }}>
            <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{reasons.length > 1 ? fullTooltip : firstReason}</span>} arrow placement="top">
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, overflow: 'hidden' }}>
                <Typography
                  variant="body2"
                  style={{
                    color: '#d32f2f',
                    fontWeight: 'bold',
                    fontSize: 12,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: reasons.length > 1 ? 140 : 200,
                    cursor: 'pointer'
                  }}
                >
                  {firstReason}
                </Typography>
                {reasons.length > 1 && (
                  <Chip
                    label={`+${reasons.length - 1}`}
                    size="small"
                    style={{
                      height: 20,
                      fontSize: 11,
                      backgroundColor: '#ffebee',
                      color: '#d32f2f',
                      fontWeight: 'bold',
                      cursor: 'pointer'
                    }}
                  />
                )}
              </div>
            </Tooltip>
            {hasNewUpload && (
              <Tooltip title={t('new_car_document_uploaded', 'New car document or info updated by driver')}>
                <Badge color="error" variant="dot">
                  <NotificationsActiveIcon style={{ color: '#ff9800', fontSize: 18 }} />
                </Badge>
              </Tooltip>
            )}
          </div>
        );
      }
    }
  ];

  const [selectedRow, setSelectedRow] = useState(null);

  const [currentPage, setCurrentPage] = useState(0);
  const [rejectCar, setRejectCar] = useState(null);
  const [rejectReasons, setRejectReasons] = useState([]);
  const [customRejectReason, setCustomRejectReason] = useState("");
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);


  useEffect(() => {
    setCurrentPage(state?.pageNo)
  }, [state])

  const handlePaginationChange = (page) => {
    setCurrentPage(page)
  };

  const options = {
    initialPage: state?.pageNo,
    pageSize: 10,
    pageSizeOptions: [10, 15, 20],
    exportCsv: (columns, data) => {
      let hArray = [];
      const headerRow = columns.map(col => {
        if (typeof col.title === 'object') {
          return col.title.props.text;
        }
        hArray.push(col.field);
        return col.title;
      });
      const dataRows = data.map(({ tableData, ...row }) => {
        row.createdAt = row.createdAt ? new Date(row.createdAt).toLocaleDateString() + ' ' + new Date(row.createdAt).toLocaleTimeString() : ''
        let dArr = [];
        for (let i = 0; i < hArray.length; i++) {
          dArr.push(row[hArray[i]]);
        }
        return Object.values(dArr);
      })
      const { exportDelimiter } = ",";
      const delimiter = exportDelimiter ? exportDelimiter : ",";
      const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
      const csvFileName = 'cars.csv';
      downloadCsv(csvContent, csvFileName);
    },
    exportButton: {
      csv: settings.AllowCriticalEditsAdmin,
      pdf: false,
    },
    rowStyle: rowData => ({
      backgroundColor: (selectedRow === rowData.tableData.id) ? colors.THIRDCOLOR : colors.WHITE
    }),
    editable: {
      backgroundColor: colors.WHITE,
      fontSize: "0.8em",
      fontWeight: 'bold ',
      fontFamily: 'Lucida Console", "Courier New", monospace'
    },
    cellStyle: {
      border: "1px solid rgba(224, 224, 224, 1)",
      textAlign: "center",
    },
    headerStyle: {
      position: "sticky",
      textAlign: 'center',
      top: "0px",
      backgroundColor: colors.SECONDARY,
      color: colors.WHITE,
      fontSize: "0.8em",
      fontWeight: 'bold ',
      fontFamily: 'Lucida Console", "Courier New", monospace',
      border: "1px solid rgba(224, 224, 224, 1)",
      minWidth: "50px"
    },
    actionsColumnIndex: -1,
  };

  const localization = {
    body: {
      addTooltip: (t('add')),
      deleteTooltip: (t('delete')),
      editTooltip: (t('edit')),
      emptyDataSourceMessage: (
        (t('blank_message'))
      ),
      editRow: {
        deleteText: (t('delete_message')),
        cancelTooltip: (t('cancel')),
        saveTooltip: (t('save'))
      },
    },
    toolbar: {
      searchPlaceholder: (t('search')),
      exportTitle: (t('export')),
    },
    header: {
      actions: (t('actions'))
    },
    pagination: {
      labelDisplayedRows: ('{from}-{to} ' + (t('of')) + ' {count}'),
      firstTooltip: (t('first_page_tooltip')),
      previousTooltip: (t('previous_page_tooltip')),
      nextTooltip: (t('next_page_tooltip')),
      lastTooltip: (t('last_page_tooltip'))
    },
  }
  return (
    carlistdata.loading ? <CircularLoading /> :
      <div ref={rootRef}>
        {data && data.length > 0 ?
          <MaterialTable
            title={t('cars')}
            onChangePage={(page) => handlePaginationChange(page)}
            columns={columns}
            style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', borderRadius: "8px", boxShadow: "4px 4px 6px #9E9E9E" }}
            data={data}
            onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
            options={options}
            localization={localization}
            editable={{
              onRowDelete: oldData =>
                settings.AllowCriticalEditsAdmin ?
                  new Promise((resolve, reject) => {
                    setTimeout(() => {
                      if (oldData.active) {
                        reject();
                        alert(t('active_car_delete'));
                      } else {
                        resolve();
                        dispatch(editCar(oldData, "Delete"));
                      }
                    }, 600);
                  })
                  :
                  new Promise(resolve => {
                    setTimeout(() => {
                      resolve();
                      alert(t('demo_mode'));
                    }, 600);
                  })
            }}
            actions={[
              {
                icon: 'add',
                tooltip: t("add_car_title"),
                isFreeAction: true,
                onClick: (event) => navigate('/cars/addcar', { state: { pageNo: currentPage } })
              },
              (rowData) => ({
                tooltip: t("edit"),
                icon: () => (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      marginRight: 0
                    }}
                  >
                    <EditIcon />
                  </div>
                ),
                onClick: (event, rowData) => {
                  navigate(`/cars/updatecar/${rowData.id}`, { state: { pageNo: currentPage } })
                }
              }),
            ]}
          />
          : <BlankTable title={t('cars')} columns={columns} data={[]} options={options}
            localization={localization} actions={[
              {
                icon: 'add',
                tooltip: t("add_car_title"),
                isFreeAction: true,
                onClick: (event) => navigate('/cars/addcar', { state: { pageNo: currentPage } })
              },

            ]} />}

        {/* Reject Dialog */}
        <Dialog open={rejectDialogOpen} onClose={() => setRejectDialogOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>{t('reject_account') || 'Reject Car'}</DialogTitle>
          <DialogContent>
            <FormControl fullWidth style={{ marginTop: 20 }}>
              <InputLabel id="reject-reason-label" required>{t('rejection_reason') || t('reason')}</InputLabel>
              <Select
                labelId="reject-reason-label"
                multiple
                value={rejectReasons}
                input={<OutlinedInput label={t('rejection_reason') || t('reason')} />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={t(value, value)} size="small" />
                    ))}
                  </Box>
                )}
                onChange={(e) => {
                  const { target: { value } } = e;
                  setRejectReasons(
                    typeof value === 'string' ? value.split(',') : value,
                  );
                }}
              >
                {CAR_REJECTION_KEYS.map((key) => (
                  <MenuItem key={key} value={key}>
                    <Checkbox checked={rejectReasons.indexOf(key) > -1} />
                    <ListItemText primary={t(key, key)} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              margin="dense"
              id="custom-reject-reason"
              label={t('custom_reason', 'Custom Note / Reason (Optional)')}
              type="text"
              fullWidth
              variant="outlined"
              value={customRejectReason}
              onChange={(e) => setCustomRejectReason(e.target.value)}
              style={{ marginTop: 15 }}
            />
          </DialogContent>
          <DialogActions style={{ padding: '16px 24px' }}>
            <MuiButton onClick={() => setRejectDialogOpen(false)} variant="outlined" style={{ color: colors.MAIN_COLOR, borderColor: colors.MAIN_COLOR, borderRadius: 8 }}>
              {t('cancel')}
            </MuiButton>
            <MuiButton
              onClick={handleRejectCar}
              variant="contained"
              disabled={rejectReasons.length === 0}
              style={{
                backgroundColor: (rejectReasons.length > 0) ? colors.RED : '#e0e0e0',
                color: (rejectReasons.length > 0) ? '#fff' : '#a0a0a0',
                borderRadius: 8,
                fontWeight: 'bold',
                boxShadow: (rejectReasons.length > 0) ? '0px 2px 4px rgba(255, 30, 29, 0.3)' : 'none'
              }}
            >
              {t('confirm_reject') || t('reject')}
            </MuiButton>
          </DialogActions>
        </Dialog>

        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          open={profileModal}
          onClose={handleProfileModal}
          className={classes.modal}
          container={() => rootRef.current}
        >
          <div style={{ maxWidth: 680, width: '92vw', backgroundColor: '#fff', padding: '24px', borderRadius: 16, boxShadow: '0 10px 30px rgba(0,0,0,0.15)', outline: 'none' }}>
            <Typography variant="h6" style={{ marginBottom: 16, fontWeight: 700, textAlign: 'center' }}>
              {t('car_images')}
            </Typography>
            <div style={{ display: "flex", flexDirection: "row", gap: 16, alignItems: "flex-start", width: "100%" }}>
              {(() => {
                const renderDocSlot = (title, field, fileInputId, defaultIcon, isInsurance = false) => {
                  const fileOrUrl = userData ? userData[field] : null;
                  const imageSrc = fileOrUrl
                    ? (fileOrUrl instanceof File ? URL.createObjectURL(fileOrUrl) : (typeof fileOrUrl === 'string' && fileOrUrl.trim() !== '' ? fileOrUrl : null))
                    : null;
                  const canEditBase = Boolean(userData);
                  // Drivers cannot edit Car Image / Car Registration when car is approved
                  const isApprovedCar = userData?.approved === true;
                  const isSlotDisabled = role === 'driver' && isApprovedCar && !isInsurance;
                  const canEdit = canEditBase && !isSlotDisabled;

                  return (
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", flex: 1, minWidth: 0 }}>
                      <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 8, textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>
                        {title}
                      </Typography>

                      {imageSrc ? (
                        <div
                          style={{
                            width: '100%',
                            height: '160px',
                            borderRadius: 10,
                            border: '1px solid #e2e8f0',
                            backgroundColor: '#f1f5f9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            position: 'relative',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                            opacity: isSlotDisabled ? 0.5 : 1,
                            filter: isSlotDisabled ? 'grayscale(60%)' : 'none',
                          }}
                          onClick={() => setViewerState({ open: true, src: imageSrc, title })}
                        >
                          <img
                            src={imageSrc}
                            alt={title}
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                              if (e.target.nextSibling) {
                                e.target.nextSibling.style.display = 'flex';
                              }
                            }}
                          />
                          <div style={{ display: 'none', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', padding: 10 }}>
                            {defaultIcon}
                            <Typography variant="caption" style={{ color: '#64748b', marginTop: 4, textAlign: 'center' }}>
                              {t('no_image_available', 'Image failed to load')}
                            </Typography>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            width: '100%',
                            height: '160px',
                            borderRadius: 10,
                            border: '2px dashed #cbd5e1',
                            backgroundColor: '#f8fafc',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 10,
                            cursor: canEdit ? 'pointer' : 'default',
                            boxSizing: 'border-box',
                            opacity: isSlotDisabled ? 0.5 : 1,
                          }}
                          onClick={() => {
                            if (canEdit) {
                              const fileInput = document.getElementById(fileInputId);
                              if (fileInput) fileInput.click();
                            }
                          }}
                        >
                          {defaultIcon}
                          <Typography variant="caption" style={{ color: '#64748b', marginTop: 6, fontWeight: 500, textAlign: 'center' }}>
                            {t('no_document', 'No Document Uploaded')}
                          </Typography>
                        </div>
                      )}

                      {canEdit ? (
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", marginTop: 10 }}>
                          <input
                            accept="image/*"
                            style={{ display: 'none' }}
                            id={fileInputId}
                            type="file"
                            onChange={(e) => {
                              const f = e.target.files[0];
                              if (f) {
                                let finalData = { ...userData };
                                finalData[field] = f;
                                setUserData(finalData);
                              }
                            }}
                          />
                          <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                            <label htmlFor={fileInputId}>
                              <Button variant="outlined" component="span" style={{ fontSize: 11, padding: '4px 12px' }}>
                                {fileOrUrl instanceof File ? fileOrUrl.name : (imageSrc ? t('change') : t('upload', 'Upload'))}
                              </Button>
                            </label>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                };

                return (
                  <>
                    {renderDocSlot(t('car_image', 'Car Image'), 'car_image', 'car-button-file', <DirectionsCarIcon sx={{ fontSize: 44, color: '#94a3b8' }} />)}
                    {renderDocSlot(t('car_registration', 'Car Registration'), 'car_registration_image', 'reg-button-file', <DescriptionIcon sx={{ fontSize: 44, color: '#94a3b8' }} />)}
                    {renderDocSlot(`${t('car_insurance', 'Car Insurance')} (Optional)`, 'car_insurance_image', 'ins-button-file', <SecurityIcon sx={{ fontSize: 44, color: '#94a3b8' }} />, true)}
                  </>
                );
              })()}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
              <Button variant="contained" color="success" onClick={() => {
                setLoading(true);
                dispatch(editCar({ ...userData, hasNewCarUpload: true, carDocUpdated: true }, "UpdateImage"));
                setProfileModal(false);
                setTimeout(() => {
                  setLoading(false);
                }, 3000);
              }} style={{ marginRight: 10 }}>
                {t('save')}
              </Button>
              <Button variant="outlined" color="error" onClick={handleProfileModal}>
                {t('cancel')}
              </Button>
            </div>
          </div>
        </Modal>
        <ImageViewerModal
          open={viewerState.open}
          src={viewerState.src}
          title={viewerState.title}
          onClose={() => setViewerState({ open: false, src: '', title: '' })}
        />
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
      </div>
  );
}